import { Segment, Divider } from 'semantic-ui-react';
import React from 'react';
import PropTypes from 'prop-types';

const RatingIncomplete = props => (
  <Segment color='red'>
    <h5>{props.title}</h5>
    <div className='button-block'>
      <button
        onClick={() => props.onBackBrandPage()}
      >
        Back to Brand Page
      </button>
      <button onClick={() => props.onBackRating()}>Back to Rating</button>
    </div>
  </Segment>
);

RatingIncomplete.propTypes = {
  title: PropTypes.string.isRequired,
  onBackBrandPage: PropTypes.func.isRequired,
  onBackRating: PropTypes.func.isRequired
}

export default RatingIncomplete;



// WEBPACK FOOTER //
// ./src/components/RatingIncomplete/RatingIncomplete.js